import { render, staticRenderFns } from "../../../public/HODOPolicy/index.htm?vue&type=template&id=0dac9738&scoped=true&external"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "../../../public/HODOPolicy/chinhsach_files/Site.css?vue&type=style&index=0&id=0dac9738&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dac9738",
  null
  
)

export default component.exports